import { types } from './certificadoDigital.actions'
import { Reducer } from '../../services/reducer.factory'
import storage from '../../services/stoage.service'

const initialState = {
  id: 'certificadoDigital',
  booleanFilter: { ativo: '' },
  selectedFilters: [],
  showHideColumns: [
    {
      label: 'Código',
      value: {
        field: 'oid',
        header: 'Código',
        columnKey: 'oid',
        sortable: true,
        columnSortField: 'oid',
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Titular',
      value: {
        field: 'titularCommonName',
        header: 'Titular',
        columnKey: 'titularCommonName',
        sortable: true,
        columnSortField: 'titularCommonName',
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Data Início',
      value: {
        field: 'dataInicio',
        header: 'Data Início',
        columnKey: 'dataInicio',
        sortable: true,
        columnSortField: 'dataInicio',
        filter: true,
        visible: true,
        fieldFormatter: 'formatarData',
      },
    },
    {
      label: 'Data Expiração',
      value: {
        field: 'dataExpiracao',
        header: 'Data Expiração',
        columnKey: 'dataExpiracao',
        sortable: true,
        columnSortField: 'dataExpiracao',
        filter: true,
        visible: true,
        fieldFormatter: 'formatarData',
      },
    },
    {
      label: 'Ativo',
      value: {
        field: 'ativo',
        header: 'Ativo',
        columnKey: 'ativo',
        sortable: true,
        columnSortField: 'ativo',
        filter: true,
        visible: true,
      },
    },
  ],
  columnsLookup: [
    {
      field: 'oid',
      header: 'Código',
      columnKey: 'oid',
      sortable: true,
      columnSortField: 'oid',
      filter: true,
      visible: true,
    },
  ],

  columns: [],
  adicionandoAnexo: false,
  currentRecord: {
    oid: '',
    dadosTitular: {
      commonName: '',
      organization: '',
      organizationalUnit: '',
      locality: '',
      state: '',
      country: '',
      distinguishedName: '',
    },
    dadosEmissor: {
      commonName: '',
      organization: '',
      organizationalUnit: '',
      locality: '',
      state: '',
      country: '',
      distinguishedName: '',
    },
    dataInicio: '',
    dataExpiracao: '',
    chavePublica: '',
    chavePrivada: '',
    ativo: true,
  },
  messages: null,
  usaListDto: false,
  ativoBooleanTypes: [
    { label: 'TODOS', value: '' },
    { label: 'Sim', value: true },
    { label: 'Não', value: false },
  ],
}

const reducer = new Reducer(initialState, types)

export function CRUDCertificadoDigitalReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels('certificadodigital')
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  switch (action.type) {
    case types.RESET:
      return reset(state, action)
    case types.MAKE_NEW:
      return initialize(state)
    case types.SET_ADICIONANDO_ANEXO:
      return setAdicionandoAnexo(state, action)
    default:
      return state
  }
}

function reset(state, action) {
  return {
    ...state,
    currentRecord: initialState.currentRecord,
    records: [],
    selectedFilters: [],
  }
}

const initialize = (state) => {
  const currentRecord = state.currentRecord
  return Object.assign({}, state, { currentRecord: currentRecord })
}

function setAdicionandoAnexo(state, action) {
  return {
    ...state,
    adicionandoAnexo: action.payload,
  }
}
